export const suppliersModalColumns = [
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    width: 64,
    align: "center",
  },
  {
    title: "Proveedor",
    dataIndex: "nombre",
    key: "nombre",
  },
  {
    title: "NIT",
    dataIndex: "nit",
    key: "nit",
    width: 180,
    align: "center",
  },
];
